import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import store from 'store'
import { ApolloProvider } from '@apollo/client'
import apolloClient from 'providers/apolloClient'
import PreviewerFrame from 'components/atoms/PreviewerFrame'
import MobileFrame from 'components/atoms/MobileFrame'
import ProcessorAppBooter from 'components/organisms/ProcessorAppBooter'
import PreviewerAppContext from 'components/organisms/PreviewerAppContext'
import ToastWrapper from 'components/atoms/ToastWrapper'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const rawClientConfig = require('./client.config.json') as { webappLayoutMode?: string }

const isFullscreen = rawClientConfig.webappLayoutMode === 'fullscreen'

const Frame: React.FC = ({ children }) => (
    isFullscreen
        ? <>{children}</>
        : <MobileFrame>{children}</MobileFrame>
)

const ReduxProviderComp = ReduxProvider as any
const ApolloProviderComp = ApolloProvider as any

const App = () => (
    <ApolloProviderComp client={apolloClient}>
        <ReduxProviderComp store={store}>
            <PreviewerAppContext>
                <Frame>
                    <PreviewerFrame>
                        <ProcessorAppBooter />
                        <ToastWrapper id="toast-container" />
                    </PreviewerFrame>
                </Frame>
            </PreviewerAppContext>
        </ReduxProviderComp>
    </ApolloProviderComp>
)

export default App
